interface Props {
  className?: string
}

export const ImgSvg: React.FC<Props> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 277 80" fill="none" className={className}>
        <path d="M6.27762 35.9569L0 39.1675V146.167H277V0.16748L271.115 5.49981H264.837L261.894 10.4928H257.971C256.925 11.3249 254.754 12.9892 254.44 12.9892C254.126 12.9892 252.086 13.9878 251.105 14.4871L242.669 15.985L237.765 17.9822L229.918 15.985L225.798 14.4871L219.913 17.9822H213.831L208.731 14.4871C206.769 13.9878 202.767 12.9892 202.453 12.9892C202.139 12.9892 199.576 11.9907 198.334 11.4914H195.195L187.74 12.9892L181.266 14.4871L178.324 17.9822L169.496 19.4801L164.984 20.978L159.883 23.4745L154.979 29.466H152.821L146.936 27.9681L141.246 23.4745L136.342 20.978H133.399L128.299 19.4801L121.04 20.978H114.174L107.308 23.4745L100.442 26.4702L95.3414 29.466L89.8484 30.9639L82.3938 29.466L76.5085 30.9639L70.6232 32.4618L65.1303 30.9639L57.6756 34.459L51.398 32.4618L45.1204 34.459H39.0389L32.5652 35.9569H25.8952L19.2252 37.4548L12.7514 34.459L6.27762 35.9569Z" fill="url(#paint0_linear_765_11346)" />
        <defs>
            <linearGradient id="paint0_linear_765_11346" x1="138.5" y1="-9.84595" x2="138.5" y2="91.4201" gradientUnits="userSpaceOnUse">
            <stop stopColor="#005FF9" stopOpacity="0.35"/>
            <stop offset="1" stopColor="#005FF9" stopOpacity="0"/>
            </linearGradient>
        </defs>
    </svg>
  )
}
